module.exports = __webpack_public_path__ + "static/power-character-91e9e1ffea62ac0a305b127053ea8b0d.png";